<template>
    <div>
        <v-container fluid class="d-flex pa-0 fullHeight">
            
            <v-container class="container-custom px-6">
                <Breadcrumbs :description="$t('modules.coursesPrice.table.breadcrumbs.description')"
                    :title="$t('modules.coursesPrice.table.breadcrumbs.title')">
                    <Button v-if="canCreate" @clicked="newCourse" :icon="breadcrumbs.button.icon"
                        :text="$t('modules.coursesPrice.table.create')" depressed></Button>
                </Breadcrumbs>
                <v-row justify="center">
                    <v-col sm="12" class="viewSpaces">
                        <SuperTable
                            :headers="headers"
                            :users="prices"
                            :clear-selected="clearSelected"
                            :pageCount="pageCount"
                            :totalItems="prices.length"
                            :permissions="{update: canUpdate, delete: canDelete}"
                            @deleteUser="(id)=>{deleteCoursePrice(id)}"
                            @bulk-delete="(items)=>{bulkDeletePopUp(items)}"
                            @pageChange="(val) => page=val"
                            @lengthPaginationChange="(val) => itemsPerPage=val"
                            @updateUser="(id)=>{updateCourse(id)}"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </div>
</template>

<script>
import SuperTable from '../Components/SuperTable.vue'
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import Button from '@/components/Button/Button';
import { $prices, $course } from '../Services';

export default {
    name: 'CoursesList',
    components: {
        SuperTable,
        Breadcrumbs,
        Button
    },
    data() {
        return {
            clearSelected: '',
            breadcrumbs: {
                title: 'Cursos extracurriculares',
                description: 'Cursos extracurriculares disponibles en el sistema.',
                button: {
                    name: 'Nuevo',
                    icon: 'mdi-plus',
                    color: 'primary'
                }
            },
            headers: [
                {
                    text: this.$t('modules.coursesPrice.table.headers.name'),
                    value: 'name',
                },
                {
                    text: this.$t('modules.coursesPrice.table.headers.status'),
                    value: 'status',
                },
                {
                    text: this.$t('modules.coursesPrice.table.headers.code'),
                    value: 'code',
                },
                {
                    text: this.$t('modules.coursesPrice.table.headers.details'),
                    value: 'details',
                },
                {
                    text: '',
                    value: 'action'
                }
            ],
            prices: [],
            page: 1,
            itemsPerPage: 500,
            itemsInAPI: null,
        }
    },
    computed: {
        canRead() {
            return this.$permissions?.portaladministrativo?.academic?.courses?.READ
        },
        canUpdate() {
            return this.$permissions?.portaladministrativo?.academic?.courses?.UPDATE
        },
        canCreate() {
            return this.$permissions?.portaladministrativo?.academic?.courses?.CREATE
        },
        canDelete() {
            return this.$permissions?.portaladministrativo?.academic?.courses?.DELETE
        },
        pageCount () {
            return this.prices.length % this.itemsPerPage === 0 ? (this.prices.length / this.itemsPerPage | 0) : (this.prices.length / this.itemsPerPage | 0) + 1
        },
    },
    methods: {
        async fetchData (page, itemsPerPage) {
            this.clearSelected = new Date().getMilliseconds().toString();
            this.prices = [];
            try {
                const response = await $prices.find(null, null, { params: { page: page - 1, length: itemsPerPage, orderBy: 'id', orientation: 'desc' } });
                const filteredPrices = response.data.content.filter(item => item.billingProducts && item.billingProducts.id === 248);
                this.prices = this.formatPrices(filteredPrices)
                this.itemsInAPI = filteredPrices.length
            } catch {
                this.prices = []
            }
        },
        formatPrices (prices) {
            return prices.map(price => ({
                id: price.id,
                code: price.billingProducts?.code || '',
                name: price.billingProducts?.name || '',
                status: price.status === true ? 'Activo' : 'Inactivo',
                details: price.priceDetails || ''
            }))
        },
        newCourse() {
            if (this.canCreate) this.$router.push('/courses/create')
        },
        updateCourse(id) {
            if (this.canRead || this.canUpdate) this.$router.push(`/courses/update/${id}`)
        },
        async deleteCoursePrice(priceId) {
            try {
                await $course.delete(`prices/${priceId}`);
                this.fetchData(this.page, this.itemsPerPage);
            } catch (error) {
                this.$store.dispatch('commons/openPopUp', {
                    title: this.$t('alert'),
                    content: [{ value: this.$t('modules.coursesPrice.table.delete_error') }],
                    actionPrimary: { text: this.$t('actions.accept'), callback() { } },
                    icon: { color: 'warning', name: 'mdi-alert' },
                    color: 'primary',
                });
            }
        },
        async bulkDelete(selectedItems) {
            const itemsForDelete = selectedItems.map((item) => {
                return {priceId: item.id}
            })
            try {
                const deleteResult = await $course.bulkDelete(itemsForDelete, {}, 'prices/bulk')  
                if (deleteResult) {
                    this.fetchData(this.page, this.itemsPerPage);
                }
            } catch (err) {
                this.$store.dispatch('commons/openPopUp', {
                    title: this.$t('modules.coursesPrice.table.delete_error'),
                    actionPrimary: {text: this.$t('actions.accept'), callback() {}},
                    icon: { color: 'error', name: 'mdi-close' },
                    color: 'primary',
                })
            }
        },
        bulkDeletePopUp(selectedItems) {
            this.$store.dispatch('commons/openPopUp', {
                title: this.$t('actions.confirmation_delete'),
                content: [
                    { value: this.$t('modules.coursesPrice.table.bulk_delete_confirm') }
                ],
                actionPrimary: {
                    text: this.$t('actions.accept'),
                    callback: () => this.bulkDelete(selectedItems)
                },
                actionSecondary: {
                    text: this.$t('actions.cancel'),
                    callback() {}
                },
                icon: {
                    color: 'error',
                    name: 'mdi-delete'
                },
                color: 'primary',
            })
        },
    },
    async mounted() {
        this.fetchData(this.page, this.itemsPerPage)
    },
}
</script>